<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1> SSR</h1>
                </div>
            </div>
        </div>
    </div>
</section>
    <ul class="breadcrumb">
        <li><a href="#">IQAC</a></li>
        <li><i class="fa fa-angle-double-right"></i></li>
        <li> SSR</li>
    </ul>
<section class="section-lg std-scholarship">
    <div class="container-fluid">
        <div class="row row-50">
            <div class="col-md-3">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">I Curricular Aspects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">II Teaching-Learning &amp; Evaluation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">III Research, Innovation &amp; Extension</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">IV Infrastructure &amp; Learning Resources</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">V Student Support &amp; Progression</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">VI Governance, Leadership &amp; Management</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab7-tab" data-toggle="tab" href="#tab7" role="tab" aria-controls="tab7" aria-selected="false">VII Institutional Values &amp; Best Practices</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab8-tab" data-toggle="tab" href="#tab8" role="tab" aria-controls="tab8" aria-selected="false">Extended Template Documents</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab9-tab" data-toggle="tab" href="#tab9" role="tab" aria-controls="tab9" aria-selected="false">Clarification</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>I Curricular Aspects</h3>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div id="accordion" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" href="#c1-1">
                                            <a class="card-title">1.1.1</a>
                                        </div>
                                        <div id="c1-1" class="card-body collapse in show" data-parent="#accordion" >
                                            <a href="https://drive.google.com/file/d/12FiHsrbyWtrQggtrfxu6HnmYDGNuAAaA/view?usp=sharing" target="_blank" class="btn-link">Effective Curriculum</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c1-2">
                                            <a class="card-title">1.1.2</a>
                                        </div>
                                        <div id="c1-2" class="card-body collapse" data-parent="#accordion" >
                                            <a href="https://drive.google.com/file/d/1ThZmQTjwhSmTLwc4I1My5tOn-XACWWHg/view?usp=sharing" target="_blank" class="btn-link">
                                            Number of certificate/diploma</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c1-3">
                                            <a class="card-title">1.1.3</a>
                                        </div>
                                        <div id="c1-3" class="card-body collapse" data-parent="#accordion" >
                                            <a href="https://drive.google.com/file/d/1wAFsdIwjRWNmAbnfrvsFcRv2t2y_hBhE/view?usp=sharing" target="_blank" class="btn-link">
                                            Participation of teachers in BoS and Academic Council</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c1-4">
                                            <a class="card-title">1.2.1</a>
                                        </div>
                                        <div id="c1-4" class="card-body collapse" data-parent="#accordion" >
                                            <a href="https://drive.google.com/file/d/1K9AmisWaVAyUqUgjUkAYYjeClyoBa_D4/view?usp=sharing" target="_blank" class="btn-link">
                                            New Courses Introduced</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion" href="#c1-5">
                                            <a class="card-title">1.2.2</a>
                                        </div>
                                        <div id="c1-5" class="card-body collapse" data-parent="#accordion" >
                                            <a href="https://drive.google.com/file/d/1F3k8ZdAyeCCJ9_TrYB9mX71xmQtBCsiY/view?usp=sharing" target="_blank" class="btn-link">
                                            Courses System</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="accordion1" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion1" href="#c1-6">
                                            <a class="card-title">1.2.3</a>
                                        </div>
                                        <div id="c1-6" class="card-body collapse" data-parent="#accordion1" >
                                            <a href="https://drive.google.com/file/d/1LGcSyuhDwlUlClSk-0CqAya0Or7iHVzQ/view?usp=sharing" target="_blank" class="btn-link">
                                            Certificate / Add-on Programs</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion1" href="#c1-7">
                                            <a class="card-title">1.3.1</a>
                                        </div>
                                        <div id="c1-7" class="card-body collapse" data-parent="#accordion1" >
                                            <a href="https://drive.google.com/file/d/1lf_3X9PC-fE7X60nH1DtgSnmor4TQaDk/view?usp=sharing" target="_blank" class="btn-link">
                                            Cross-cutting issues</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion1" href="#c1-8">
                                            <a class="card-title">1.3.2</a>
                                        </div>
                                        <div id="c1-8" class="card-body collapse" data-parent="#accordion1" >
                                            <a href="https://drive.google.com/file/d/1i1frdjvlx3fH_wmnSwt3QjE0zoKi2lBi/view?usp=sharing" target="_blank" class="btn-link">
                                            Value added courses</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion1" href="#c1-9">
                                            <a class="card-title">1.3.3</a>
                                        </div>
                                        <div id="c1-9" class="card-body collapse" data-parent="#accordion1" >
                                            <a href="https://drive.google.com/file/d/10X2nrl0lu07H4olNsxb1wu-yxzfcsbmC/view?usp=sharing" target="_blank" class="btn-link">
                                            Field Projects</a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion1" href="#c1-10">
                                            <a class="card-title">1.4.2</a>
                                        </div>
                                        <div id="c1-10" class="card-body collapse" data-parent="#accordion1" >
                                            <a href="https://drive.google.com/file/d/1Cj41ivbVM54spKICCjcQvm9IQj2vJqb6/view?usp=sharing" target="_blank" class="btn-link">
                                            Feedback Process</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
                        <div class="inner-title"  >
                            <h3>II Teaching-Learning &amp; Evaluation
                            </h3>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div id="accordion2" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" href="#c2-1">
                                            <a class="card-title">2.1.1</a>
                                        </div>
                                        <div id="c2-1" class="card-body collapse in show" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1CLbrrg5pxSEfU6gtxFFK9zNbl6zBPBRQ/view?usp=sharing" target="_blank" class="btn-link">
                                            OMS Student
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-2">
                                            <a class="card-title">2.1.2</a>
                                        </div>
                                        <div id="c2-2" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1kPbFoTUACs4nbTpCLuzPAw7b7Y1vVSbE/view?usp=sharing" target="_blank" class="btn-link">
                                            Average Enrolment
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-3">
                                            <a class="card-title">2.1.3</a>
                                        </div>
                                        <div id="c2-3" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1GDAMCc2tDtLwFccSHWhpHpRRs-Xlx1Z4/view?usp=sharing" target="_blank" class="btn-link">
                                            Categories Data
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-4">
                                            <a class="card-title">2.2.1</a>
                                        </div>
                                        <div id="c2-4" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1Afk5EwOT9Ex8yRqx4oPffBezExoJRBJG/view?usp=sharing" target="_blank" class="btn-link">
                                            Slowand Advanced Learner
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-5">
                                            <a class="card-title">2.2.3</a>
                                        </div>
                                        <div id="c2-5" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1hZZsdaiGu0mqSmjxNaer3GlUe1WsspF9/view?usp=sharing" target="_blank"class="btn-link">
                                            Percentage of differently abled students
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-6">
                                            <a class="card-title">2.3.1</a>
                                        </div>
                                        <div id="c2-6" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1Z3DDSUBJqGRJEM2yEz0h4uUx9J0Hppnn/view?usp=sharing" target="_blank" class="btn-link">
                                            Student Centric Method
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-7">
                                            <a class="card-title">2.3.2</a>
                                        </div>
                                        <div id="c2-7" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1ulfrQfR3NPEo2u18iH3c4soFomuosglm/view?usp=sharing" target="_blank" class="btn-link">
                                            ICT Tools Faculty List
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-8">
                                            <a class="card-title">2.3.3</a>
                                        </div>
                                        <div id="c2-8" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1KORrZ2c6edRyELA1POvDtYuYmWV46BCF/view?usp=sharing" target="_blank" class="btn-link">
                                            Mentor Mentee
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-9">
                                            <a class="card-title">2.3.4</a>
                                        </div>
                                        <div id="c2-9" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/12HrsMqaZqlrlr1tm63Yh2YFpPr6todbd/view?usp=sharing" target="_blank" class="btn-link">
                                            Innovative & Creative
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion2" href="#c2-10">
                                            <a class="card-title">2.4.1</a>
                                        </div>
                                        <div id="c2-10" class="card-body collapse" data-parent="#accordion2" >
                                            <a href="https://drive.google.com/file/d/1YV_YhzxzpxLH0gFbL3mh89jKMKwQ3yfU/view?usp=sharing" target="_blank" class="btn-link">
                                            Average Percentage of teachers
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="accordion3" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3"  href="#c2-11">
                                            <a class="card-title">2.4.2</a>
                                        </div>
                                        <div id="c2-11" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1rmhZrtu72DxIdUdJ3jeCfm_WTh0FksQJ/view?usp=sharing" target="_blank" class="btn-link">
                                            PHD
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-12">
                                            <a class="card-title">2.4.4</a>
                                        </div>
                                        <div id="c2-12" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1j9uz2sd1pc5nh6E0mAJvuQlaa3yGzhfC/view?usp=sharing" target="_blank" class="btn-link">
                                            Faculty Awards Recognition
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-13">
                                            <a class="card-title">2.4.5</a>
                                        </div>
                                        <div id="c2-13" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1OHfBsZXy4DguhIc_3PdI9-a-uaBeYoL3/view?usp=sharing" target="_blank" class="btn-link">
                                            OMS Document
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-14">
                                            <a class="card-title">2.5.1</a>
                                        </div>
                                        <div id="c2-14" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1KsLOvudYcvxGGpBhyIs2CQyRQhbCeNrF/view?usp=sharing" target="_blank" class="btn-link">
                                            Reforms CIE
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-15">
                                            <a class="card-title">2.5.2</a>
                                        </div>
                                        <div id="c2-15" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/17maSXAAczqg6BxS3PpeT9-KlDB_8XoMX/view?usp=sharing" target="_blank" class="btn-link">
                                            Internal Assessment
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-16">
                                            <a class="card-title">2.5.3</a>
                                        </div>
                                        <div id="c2-16" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1ROFWakjv5ww99d3mAWMi9iUT9PJVvtiN/view?usp=sharing" target="_blank" class="btn-link">
                                            Exam Grievances
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-17">
                                            <a class="card-title">2.5.4</a>
                                        </div>
                                        <div id="c2-17" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1kQRgDvaC_p_ew5EitQx1GjTwZSOjCYX8/view?usp=sharing" target="_blank" class="btn-link">
                                            Calendar
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-18">
                                            <a class="card-title">2.6.1</a>
                                        </div>
                                        <div id="c2-18" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1UlliOfFwlPEoKMRqNAmmeUp-OmBzhOeu/view?usp=sharing" target="_blank" class="btn-link">
                                            PO & PSO
                                            </a>    
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-19">
                                            <a class="card-title">2.6.2</a>
                                        </div>
                                        <div id="c2-19" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/11yW_iJE4oaIetEgNswjaYjoLPjKQ3vQ4/view?usp=sharing" target="_blank" class="btn-link">
                                            Attainment of PO , PSOs & CO
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion3" href="#c2-20">
                                            <a class="card-title">2.6.3</a>
                                        </div>
                                        <div id="c2-20" class="card-body collapse" data-parent="#accordion3" >
                                            <a href="https://drive.google.com/file/d/1l_3ywKR_8Og73AOnG7mZEP4G6bxdQTzj/view?usp=sharing" target="_blank" class="btn-link">Result
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                        <div class="inner-title"  >
                            <h3>III Research, Innovation &amp; Extension
                            </h3>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div id="accordion4" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" href="#c3-1">
                                            <a class="card-title">3.1.1</a>
                                        </div>
                                        <div id="c3-1" class="card-body collapse in show" data-parent="#accordion4" >
                                            <a href="#" class="btn-link">
                                            Research Project Grant
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion4" href="#c3-2">
                                            <a class="card-title">3.1.2</a>
                                        </div>
                                        <div id="c3-2" class="card-body collapse" data-parent="#accordion4" >
                                            <a href="#" class="btn-link">
                                            Letters of recognition as research guides
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion4" href="#c3-3">
                                            <a class="card-title">3.2.1</a>
                                        </div>
                                        <div id="c3-3" class="card-body collapse" data-parent="#accordion4" >
                                            <a href="https://drive.google.com/file/d/19OszqduV1jza--D2PZaUlaa_xtuBMqQL/view?usp=sharing" target="_blank" class="btn-link">
                                            Ecosystem for Innovations 
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion4" href="#c3-4">
                                            <a class="card-title">3.2.2</a>
                                        </div>
                                        <div id="c3-4" class="card-body collapse" data-parent="#accordion4" >
                                            <a href="https://drive.google.com/file/d/19zV4DdAufMYgFiVP0cPxVVoF3JgdqT7v/view?usp=sharing" target="_blank" class="btn-link">
                                            IPR Activities 
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion4" href="#c3-5">
                                            <a class="card-title">3.3.1</a>
                                        </div>
                                        <div id="c3-5" class="card-body collapse" data-parent="#accordion4" >
                                            <a href="https://drive.google.com/file/d/1erBma1ZPQ0uKE8nRoY04lRyZWVuUJBOY/view?usp=sharing" target="_blank" class="btn-link">
                                            Code of Ethics-To check Malpractices & Plagiarism
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion4" href="#c3-6">
                                            <a class="card-title">3.3.2</a>
                                        </div>
                                        <div id="c3-6" class="card-body collapse" data-parent="#accordion4" >
                                            <a href="https://drive.google.com/file/d/1ABTiZalwpToNR4INonWu8prKE0WVLtyL/view?usp=sharing" target="_blank" class="btn-link">
                                            Incentives to Teachers 
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion4" href="#c3-7">
                                            <a class="card-title">3.3.4</a>
                                        </div>
                                        <div id="c3-7" class="card-body collapse" data-parent="#accordion4" >
                                            <a href="https://drive.google.com/file/d/1MqV0zrvluf6AMhgAi7FOhGJkk2iq115M/view?usp=sharing" target="_blank" class="btn-link">
                                            Research Papers in UGC Journals
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="accordion5" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion5"  href="#c3-11">
                                            <a class="card-title">3.3.5 </a>
                                        </div>
                                        <div id="c3-11" class="card-body collapse" data-parent="#accordion5" >
                                            <a href="https://drive.google.com/file/d/158P1fHRdSnY4rD_vC-RxeC3v92yFqNig/view?usp=sharing" target="_blank" class="btn-link">
                                            Books & Chapters and Papers in National/International Conferences
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion5" href="#c3-12">
                                            <a class="card-title">3.4.1 </a>
                                        </div>
                                        <div id="c3-12" class="card-body collapse" data-parent="#accordion5" >
                                            <a href="https://drive.google.com/file/d/10lWUzGWRQ8DNral1dDuG_5bxNRLXIWDx/view?usp=sharing" target="_blank" class="btn-link">
                                            Extension Activities
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion5" href="#c3-13">
                                            <a class="card-title">3.4.2</a>
                                        </div>
                                        <div id="c3-13" class="card-body collapse" data-parent="#accordion5" >
                                            <a href="https://drive.google.com/file/d/1KGewaA-fStWK7pV5LcYoKqIAvVF9UE5T/view?usp=sharing" target="_blank" class="btn-link">
                                            Awards and Recognition Received
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion5" href="#c3-14">
                                            <a class="card-title">3.4.3</a>
                                        </div>
                                        <div id="c3-14" class="card-body collapse" data-parent="#accordion5" >
                                            <a href="https://drive.google.com/file/d/1v--npFMSViY0VrrWrImLBuNUEdkUnsnP/view?usp=sharing" target="_blank" class="btn-link">
                                            Extension & Outreached programs-NSS/NCC etc.
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion5" href="#c3-15">
                                            <a class="card-title">3.4.4</a>
                                        </div>
                                        <div id="c3-15" class="card-body collapse" data-parent="#accordion5" >
                                            <a href="https://drive.google.com/file/d/19HojzKVWNzgLhQLM1oLjfWO3-DaJFuHg/view?usp=sharing" target="_blank" class="btn-link">
                                            Student Participation in Extension Activities
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion5" href="#c3-16">
                                            <a class="card-title">3.5.1 </a>
                                        </div>
                                        <div id="c3-16" class="card-body collapse" data-parent="#accordion5" >
                                            <a href="https://drive.google.com/file/d/1wWnkXDt15Xjy8Rj8UKmL42tyMZoPN1vj/view?usp=sharing" target="_blank" class="btn-link">
                                            Linkages For Faculty & Student Exchange
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion5" href="#c3-17">
                                            <a class="card-title">3.5.2 </a>
                                        </div>
                                        <div id="c3-17" class="card-body collapse" data-parent="#accordion5" >
                                            <a href="https://drive.google.com/file/d/1x9bUPdHpRBg3dCMiddX3iLePyOzwuvsP/view?usp=sharing" target="_blank" class="btn-link">
                                            Functional MoUs with institutions/ industry/ corporate houses
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
                        <div class="inner-title"  >
                            <h3>IV Infrastructure &amp; Learning Resources
                            </h3>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div id="accordion6" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" href="#c4-1">
                                            <a class="card-title">4.1.1</a>
                                        </div>
                                        <div id="c4-1" class="card-body collapse in show" data-parent="#accordion6" >
                                            <a href="https://drive.google.com/file/d/1oP58IMAeTaE6YvjINb0G4pqqZ8JiieqV/view?usp=sharing" target="_blank" class="btn-link">
                                            Teaching Learning Facility
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion6" href="#c4-2">
                                            <a class="card-title">4.1.2</a>
                                        </div>
                                        <div id="c4-2" class="card-body collapse" data-parent="#accordion6" >
                                            <a href="https://drive.google.com/file/d/1BlCAIW0QmEPH4ZiCiUmV8OdRycdJHebp/view?usp=sharing" target="_blank" class="btn-link">
                                            Sports, Games, etc Facility
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion6" href="#c4-3">
                                            <a class="card-title">4.1.3</a>
                                        </div>
                                        <div id="c4-3" class="card-body collapse" data-parent="#accordion6" >
                                            <div class="row">
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1si7Xt0hkET3JkyeJO9HFpUe4g7PhTQC0/view?usp=sharing" target="_blank" class="btn-link">
                                                    Classrooms & Seminar halls with ICT
                                                    </a>
                                                </div>
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1G7hw06NK5VIF9Hpql-6Sv7Tzoc-zYzAk/view?usp=sharing" target="_blank" class="btn-link">
                                                    Video
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion6" href="#c4-4">
                                            <a class="card-title">4.1.4 </a>
                                        </div>
                                        <div id="c4-4" class="card-body collapse" data-parent="#accordion6" >
                                            <div class="row">
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1OhuCA00KtEhtFbE9hrSkLwan5P86asgc/view?usp=sharing" target="_blank" class="btn-link">
                                                    Budget estimates & audited utilization statements for infrastructure
                                                    </a>
                                                </div>
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1GEyGw5jhudV5J6GbDAkaieoVYRxjfq8l/view?usp=sharing" target="_blank" class="btn-link">
                                                    Audited Statement
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion6" href="#c4-5">
                                            <a class="card-title">4.2.1</a>
                                        </div>
                                        <div id="c4-5" class="card-body collapse" data-parent="#accordion6" >
                                            <a href="https://drive.google.com/file/d/1gYeJCDjifLudxA3JvJYeWTJwLNZixkbI/view?usp=sharing" target="_blank" class="btn-link">
                                            ILMS in Library
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion6" href="#c4-6">
                                            <a class="card-title">4.2.2</a>
                                        </div>
                                        <div id="c4-6" class="card-body collapse" data-parent="#accordion6" >
                                            <a href="https://drive.google.com/file/d/14LVgVJUuWKymdyFIcJ-zVmoj4UV98K0x/view?usp=sharing" target="_blank" class="btn-link">
                                            Rare books, manuscripts, special reports, etc. In library
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion6" href="#c4-7">
                                        <a class="card-title">4.2.3</a>
                                    </div>
                                    <div id="c4-7" class="card-body collapse" data-parent="#accordion6" >
                                        <a href="https://drive.google.com/file/d/1IufFvO-pKmGBwxO-_d593rtt-IjMvMfj/view?usp=sharing" target="_blank" class="btn-link">
                                        e-Journals,  e-Shodhsindhu, Shodhganga, e-Books
                                        </a>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion6" href="#c4-8">
                                        <a class="card-title">4.2.4</a>
                                    </div>
                                    <div id="c4-8" class="card-body collapse" data-parent="#accordion6" >
                                        <div class="row">
                                            <div class="col-md-6 col-sm-12"> 
                                                <a href="https://drive.google.com/file/d/1rfT-t7YVUP2ScQN97KXg_yATldpTt1mO/view?usp=sharing" target="_blank" class="btn-link">
                                                Audited statements regarding purchase of books and journals
                                                </a>
                                            </div>
                                            <div class="col-md-6 col-sm-12"> 
                                                <a href="https://drive.google.com/file/d/1dipAf0nwAJWCUSYzUak2sreR8OB99vu0/view?usp=sharing" target="_blank" class="btn-link">
                                                Audited Statement
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="accordion7" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7"  href="#c4-11">
                                            <a class="card-title">4.2.5  </a>
                                        </div>
                                        <div id="c4-11" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/15lT4sQTU2X2QXCYRPR5Ywb4BeJvvAKMr/view?usp=sharing" target="_blank" class="btn-link">
                                            Remote access to e-resources
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7" href="#c4-12">
                                            <a class="card-title">4.2.6  </a>
                                        </div>
                                        <div id="c4-12" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/1GV869tOOqV63v98CbqHSWCsBhtFypB7f/view?usp=sharing" target="_blank" class="btn-link">
                                            Usage of Library by Teachers and Students
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7" href="#c4-13">
                                            <a class="card-title">4.3.1</a>
                                        </div>
                                        <div id="c4-13" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/1uoffuiiL0ejqS-OlVL9Jc73XemfVDDQ1/view?usp=sharing" target="_blank" class="btn-link">
                                            Institutional IT Facility Updation
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7" href="#c4-14">
                                            <a class="card-title">4.3.2  </a>
                                        </div>
                                        <div id="c4-14" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/1WiQqmq8Z2TGFpd6aAex4aEH4LN3Utg7W/view?usp=sharing" target="_blank" class="btn-link">
                                            Student-Computer Ratio
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7" href="#c4-15">
                                            <a class="card-title">4.3.3</a>
                                        </div>
                                        <div id="c4-15" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/1BmQ410dcgwMUeVCLVK5a8hcoINDQKRU9/view?usp=sharing"  target="_blank" class="btn-link">
                                            Internet Bandwidth
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7" href="#c4-16">
                                            <a class="card-title">4.3.4 </a>
                                        </div>
                                        <div id="c4-16" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/1VNx3oY7LTz494pwrLxK-jgVLy9BNRmEo/view?usp=sharing" target="_blank" class="btn-link">
                                            e-content development facilities
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7" href="#c4-17">
                                            <a class="card-title">4.4.1  </a>
                                        </div>
                                        <div id="c4-17" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/1TYz7RXlzcYJS-kWMJ6KutlwyIly5b-6y/view?usp=sharing" target="_blank" class="btn-link">
                                            Audited statements of accounts on maintenance of campus 
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion7" href="#c4-18">
                                            <a class="card-title">4.4.2 </a>
                                        </div>
                                        <div id="c4-18" class="card-body collapse" data-parent="#accordion7" >
                                            <a href="https://drive.google.com/file/d/1UhFIfrCim3iZSQgGs7Nf_rpK_A9yEQv6/view?usp=sharing" target="_blank" class="btn-link">
                                            Procedures & Systems for utilising physical, academic and support facilities
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
                        <div class="inner-title"  >
                            <h3>V Student Support &amp; Progression
                            </h3>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div id="accordion8" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" href="#c5-1">
                                            <a class="card-title">5.1.1</a>
                                        </div>
                                        <div id="c5-1" class="card-body collapse in show" data-parent="#accordion8" >
                                            <a href="https://drive.google.com/file/d/1gkoZOGIUwXDpCuitMVbi7hCcpT_RBHND/view?usp=sharing" target="_blank" class="btn-link">
                                            Scholarship and Free-ship
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion8" href="#c5-2">
                                            <a class="card-title">5.1.2 </a>
                                        </div>
                                        <div id="c5-2" class="card-body collapse" data-parent="#accordion8" >
                                            <a href="https://drive.google.com/file/d/1_bK6HeEX_q-GuCd89AkWCIgoSOqc3Gie/view?usp=sharing" target="_blank" class="btn-link">
                                            Scholarship/freeships other than Govt Schemes
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion8" href="#c5-3">
                                            <a class="card-title">5.1.3</a>
                                        </div>
                                        <div id="c5-3" class="card-body collapse" data-parent="#accordion8" >
                                            <a href="https://drive.google.com/file/d/10fOdRt5abqR6Cj4-cF6shgngsUfq3s_b/view?usp=sharing" target="_blank" class="btn-link">
                                            Capability Enhancement and Development Schemes 
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion8" href="#c5-4">
                                            <a class="card-title">5.1.4</a>
                                        </div>
                                        <div id="c5-4" class="card-body collapse" data-parent="#accordion8" >
                                            <a href="https://drive.google.com/file/d/1k_oKBS92U5_iY3aNDaQ0DRrHOO7dcA-E/view?usp=sharing" target="_blank" target="_blank" class="btn-link">
                                            Competitive examinations and career counselling for students
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion8" href="#c5-5">
                                            <a class="card-title">5.1.5</a>
                                        </div>
                                        <div id="c5-5" class="card-body collapse" data-parent="#accordion8" >
                                            <a href="https://drive.google.com/file/d/1NYh9HsKYuPj6o5jn2oVvDuRhXI-flGuK/view?usp=sharing" target="_blank" class="btn-link">
                                            Vocational Education – Benefited students
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion8" href="#c5-6">
                                            <a class="card-title">5.1.6</a>
                                        </div>
                                        <div id="c5-6" class="card-body collapse" data-parent="#accordion8" >
                                            <a href="https://drive.google.com/file/d/1e0Uxk9oMMQ3fTB6ArKHbjodd47QVo8tJ/view?usp=sharing" target="_blank" class="btn-link">
                                            Student redressal, Sexual harassment and anti-ragging committee 
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion8" href="#c5-7">
                                        <a class="card-title">5.2.1 </a>
                                    </div>
                                    <div id="c5-7" class="card-body collapse" data-parent="#accordion8" >
                                        <a href="https://drive.google.com/file/d/1jInC4urj-1FNybvlpZbfRCR4hxiY8F6E/view?usp=sharing" target="_blank" class="btn-link">
                                        Appointment/Offer Letter
                                        </a>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion8" href="#c5-8">
                                        <a class="card-title">5.2.2</a>
                                    </div>
                                    <div id="c5-8" class="card-body collapse" data-parent="#accordion8" >
                                        <a href="https://drive.google.com/file/d/1laZQj5YMeT5VFjw_D_f7Is9k9j9Xu2zK/view?usp=sharing" target="_blank" class="btn-link">
                                        Data Student progression to higher education
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="accordion9" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion9"  href="#c5-11">
                                            <a class="card-title">5.2.3  </a>
                                        </div>
                                        <div id="c5-11" class="card-body collapse" data-parent="#accordion9" >
                                            <a href="https://drive.google.com/file/d/1zZlATID0AWMcdhjXUv37VJGZRQ4yzvtU/view?usp=sharing" target="_blank" class="btn-link">
                                            Students qualifying state/national/international level examination
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion9" href="#c5-12">
                                            <a class="card-title">5.3.1   </a>
                                        </div>
                                        <div id="c5-12" class="card-body collapse" data-parent="#accordion9" >
                                            <a href="https://drive.google.com/file/d/1NrXY9MCGuIi9Hxrtk5pIq3UE3cZIPRc7/view?usp=sharing" target="_blank" class="btn-link">
                                            Awards And Medals
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion9" href="#c5-13">
                                            <a class="card-title">5.3.2 </a>
                                        </div>
                                        <div id="c5-13" class="card-body collapse" data-parent="#accordion9" >
                                            <a href="https://drive.google.com/file/d/17sqa6yV1O0U83NF9xxkqHMja8YkS8hNr/view?usp=sharing" target="_blank" class="btn-link">
                                            Activities under SRC
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion9" href="#c5-14">
                                            <a class="card-title">5.3.3</a>
                                        </div>
                                        <div id="c5-14" class="card-body collapse" data-parent="#accordion9" >
                                            <a href="https://drive.google.com/file/d/1dUNawxPtmU_HbuJML0g2EHZJI9zK5ba4/view?usp=sharing" target="_blank" class="btn-link">
                                            Sports and Cultural Activities/Competition
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion9" href="#c5-15">
                                            <a class="card-title">5.4.1  </a>
                                        </div>
                                        <div id="c5-15" class="card-body collapse" data-parent="#accordion9" >
                                            <a href="https://drive.google.com/file/d/12mFLdbODPFo82sRzRSgrQPy90gDjlk6j/view?usp=sharing" target="_blank" class="btn-link">
                                            Alumni Association Contribution
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion9" href="#c5-16">
                                            <a class="card-title">5.4.2 </a>
                                        </div>
                                        <div id="c5-16" class="card-body collapse" data-parent="#accordion9" >
                                            <a href="https://drive.google.com/file/d/1WRfibzYCbidVJNu_NQ6LbQglwaLbhSWB/view?usp=sharing" class="btn-link">
                                            Alumni Contribution
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion9" href="#c5-17">
                                            <a class="card-title">5.4.3 </a>
                                        </div>
                                        <div id="c5-17" class="card-body collapse" data-parent="#accordion9" >
                                            <a href="https://drive.google.com/file/d/1mHefU5M8Pbm-nJ-PCE9rncfTumhix2h-/view?usp=sharing" target="_blank" class="btn-link">
                                            Alumni Association meetings
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">
                        <div class="inner-title"  >
                            <h3>VI Governance, Leadership &amp; Management
                            </h3>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div id="accordion10" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" href="#c6-1">
                                            <a class="card-title">6.1.1</a>
                                        </div>
                                        <div id="c6-1" class="card-body collapse in show" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/14-0lsuZoZzcjyqRsX1R-sPX23Vu9hnE0/view?usp=sharing" target="_blank" class="btn-link">
                                            Effective Leadership
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-2">
                                            <a class="card-title">6.1.2</a>
                                        </div>
                                        <div id="c6-2" class="card-body collapse" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/1KfTwPL7VHjSIgqQU3Fccc3KxdQijiuF7/view?usp=sharing" target="_blank" class="btn-link">
                                            Decentralisation &amp; Participative Management
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-3">
                                            <a class="card-title">6.2.1 </a>
                                        </div>
                                        <div id="c6-3" class="card-body collapse" data-parent="#accordion10" >
                                            <div class="row">
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1ka-3qLXIU1CLYvLVIhxxjeekKp2E7VDz/view?usp=sharing" target="_blank" class="btn-link">
                                                    Strategic Plan and deployment documents
                                                    </a>
                                                </div>
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1JlitC8J9PemOrNk-9PGFeCsKrAm5yBKi/view?usp=sharing" target="_blank" class="btn-link">
                                                    Strategic Plan and deployment 
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-4">
                                            <a class="card-title">6.2.2</a>
                                        </div>
                                        <div id="c6-4" class="card-body collapse" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/1GS99RKBkKXViwnhVShNmy5fvPYmhRnJP/view?usp=sharing" target="_blank" class="btn-link">
                                            Organogram of the Institution
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-5">
                                            <a class="card-title">6.2.3</a>
                                        </div>
                                        <div id="c6-5" class="card-body collapse" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/1_fGS09WxoVCGY_aBi7mUMrm6JYflFux6/view?usp=sharing" target="_blank" class="btn-link">
                                            E-governance Documents
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-6">
                                            <a class="card-title">6.2.4</a>
                                        </div>
                                        <div id="c6-6" class="card-body collapse" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/1CqBg4tSJGR-eBqXRYg8oXP4niPZ5vHtD/view?usp=sharing" target="_blank" class="btn-link">
                                            Effectiveness of various committees / bodies
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-7">
                                            <a class="card-title">6.3.1</a>
                                        </div>
                                        <div id="c6-7" class="card-body collapse" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/1DJtDuCOXzeQfiKueQBZBXnbya4ghDbw1/view?usp=sharing" target="_blank" class="btn-link">
                                            Effective welfare measures
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-8">
                                            <a class="card-title">6.3.2 </a>
                                        </div>
                                        <div id="c6-8" class="card-body collapse" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/1uOrdu3aMLPMutc6qMzSkBOYYeG7rnd3H/view?usp=sharing" target="_blank" class="btn-link">
                                            Teachers provided with financial Support
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion10" href="#c6-9">
                                            <a class="card-title">6.3.3</a>
                                        </div>
                                        <div id="c6-9" class="card-body collapse" data-parent="#accordion10" >
                                            <a href="https://drive.google.com/file/d/1OeFGFS4of8BRKSoDCetwlq4bRWHoCNg2/view?usp=sharing" target="_blank" class="btn-link">
                                            Organising professional development programs
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="accordion11" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11"  href="#c6-11">
                                            <a class="card-title">6.3.4 </a>
                                        </div>
                                        <div id="c6-11" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="https://drive.google.com/file/d/12W9OyK3GH-4s3JY7co-KWt-Am7u25fwg/view?usp=sharing" target="_blank" class="btn-link">
                                            Certificates “Attending Professional development programs”
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-12">
                                            <a class="card-title">6.3.5</a>
                                        </div>
                                        <div id="c6-12" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="https://drive.google.com/file/d/1aUQN6Cx3BDd30ohnC0NEQyjNWDCcnWDs/view?usp=sharing" target="_blank" class="btn-link">
                                            Performance Appraisal System for Teaching and Non-Teaching Staff
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-13">
                                            <a class="card-title">6.4.1</a>
                                        </div>
                                        <div id="c6-13" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="https://drive.google.com/file/d/1UbRveQFy2ToG1JxQ9skB2nQeNYlW5rbR/view?usp=sharing" target="_blank" class="btn-link">
                                            Internal And external Financial Audit
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-14">
                                            <a class="card-title">6.4.2</a>
                                        </div>
                                        <div id="c6-14" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="#" class="btn-link">
                                            Funds/Grant Received from Non-Government Bodies
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-15">
                                            <a class="card-title">6.5.1 </a>
                                        </div>
                                        <div id="c6-15" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="https://drive.google.com/file/d/1ifKIQotW2Oy_Dxgc1speeZtKtLhYXohb/view?usp=sharing" target="_blank" class="btn-link">
                                            Contribution from IQAC
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-16">
                                            <a class="card-title">6.5.2</a>
                                        </div>
                                        <div id="c6-16" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="https://drive.google.com/file/d/1I6L1Bbh_790-Z60rA8vCDhAtHrLUYO-8/view?usp=sharing" target="_blank" class="btn-link">
                                            Teaching Learning Process
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-17">
                                            <a class="card-title">6.5.3</a>
                                        </div>
                                        <div id="c6-17" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="https://drive.google.com/file/d/1JtN2osHawstaWZz32DEvrdkPd2SSzVUr/view?usp=sharing" target="_blank" class="btn-link">
                                            Quality Initiatives by IQAC
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-18">
                                            <a class="card-title">6.5.4 </a>
                                        </div>
                                        <div id="c6-18" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="#" class="btn-link">
                                            Quality Assurance Initiatives
                                            </a>   
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion11" href="#c6-19">
                                            <a class="card-title">6.5.5</a>
                                        </div>
                                        <div id="c6-19" class="card-body collapse" data-parent="#accordion11" >
                                            <a href="https://drive.google.com/file/d/1l-GnbE1oz4_Buyau93Z309Qid37dYE5y/view?usp=sharing" target="_blank" class="btn-link">
                                            Incremental improvements
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab7" role="tabpanel" aria-labelledby="tab7-tab">
                        <div class="inner-title"  >
                            <h3>VII Institutional Values &amp; Best Practices
                            </h3>
                           
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div id="accordion12" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" href="#c6-1">
                                            <a class="card-title">7.1.1</a>
                                        </div>
                                        <div id="c6-1" class="card-body collapse in show" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/12tZ9XTbF3z-j7jLe0m35lE6bYZVD118i/view?usp=sharing" target="_blank" class="btn-link">
                                            Gender Equity Promotion Programs
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-2">
                                            <a class="card-title">7.1.2  </a>
                                        </div>
                                        <div id="c6-2" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/1I5xD9Eg53kEl-1DwWqQE65_gy5d191iQ/view?usp=sharing" target="_blank" class="btn-link">
                                            Gender Sensitivity
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-3">
                                            <a class="card-title">7.1.3</a>
                                        </div>
                                        <div id="c6-3" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="#" class="btn-link">
                                            Alternate Energy Initiatives 
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-4">
                                            <a class="card-title">7.1.4</a>
                                        </div>
                                        <div id="c6-4" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/1Ok9M3NDQdNnX_pZ6BN2jISsu4sdf0Ixa/view?usp=sharing" target="_blank" class="btn-link">
                                            Annual Lighting Power Requirement through LED Bulbs
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-5">
                                            <a class="card-title">7.1.5 </a>
                                        </div>
                                        <div id="c6-5" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/1KGXE5agIrkI0m0e3z2HrlwUS_vbCmUEM/view?usp=sharing" target="_blank" class="btn-link">
                                            Waste Management Steps
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-6">
                                            <a class="card-title">7.1.6</a>
                                        </div>
                                        <div id="c6-6" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/1ST2_8Akrm8Dht8oojWVQwMJm4U01sSyY/view?usp=sharing" target="_blank" class="btn-link">
                                            Rain Water Harvesting
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-7">
                                            <a class="card-title">7.1.7 </a>
                                        </div>
                                        <div id="c6-7" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/1XMSBnOiz-_EhXYDQzY55pm_XHfM6zgYc/view?usp=sharing" target="_blank" class="btn-link">
                                            Green Practices
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-8">
                                            <a class="card-title">7.1.8</a>
                                        </div>
                                        <div id="c6-8" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/1mtq3MNk4CfsjtmrWWLnSY9QQh_0VsItz/view?usp=sharing" target="_blank" class="btn-link">
                                            Expenditure on Green Initiatives & Waste Management
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-9">
                                            <a class="card-title">7.1.9</a>
                                        </div>
                                        <div id="c6-9" class="card-body collapse" data-parent="#accordion12" >
                                            <a href="https://drive.google.com/file/d/11hzEEo61h_Ocb97PI6cGGit-3T-PT-Nv/view?usp=sharing" target="_blank" class="btn-link">
                                            Resources available in the Institution
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion12" href="#c6-10">
                                            <a class="card-title">7.1.10</a>
                                        </div>
                                        <div id="c6-10" class="card-body collapse" data-parent="#accordion12" >
                                            <div class="row">
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1W-35HT_4jKIdgf-t1jguPhUUw-2bHG9z/view?usp=sharing" target="_blank" class="btn-link">
                                                    Locational Advantages and Disadvantages
                                                    </a>
                                                </div>
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1SsPeGEqFV2BpZYZHQq2CPDkA658afbgb/view?usp=sharing" target="_blank" class="btn-link">
                                                    Video
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div id="accordion13" class="accordion">
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13"  href="#c6-11">
                                            <a class="card-title">7.1.12</a>
                                        </div>
                                        <div id="c6-11" class="card-body collapse" data-parent="#accordion13" >
                                            <div class="row">
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1E_Iy3YLcgfPetAcq3LJT0CtORkRL3FIs/view?usp=sharing" target="_blank" class="btn-link">
                                                    Governing Body
                                                    </a>
                                                </div>
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1E_Iy3YLcgfPetAcq3LJT0CtORkRL3FIs/view?usp=sharing" target="_blank" class="btn-link">
                                                    Principal
                                                    </a>
                                                </div>
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1E_Iy3YLcgfPetAcq3LJT0CtORkRL3FIs/view?usp=sharing" target="_blank" class="btn-link">
                                                    Faculty
                                                    </a>
                                                </div>
                                                <div class="col-md-6 col-sm-12"> 
                                                    <a href="https://drive.google.com/file/d/1E_Iy3YLcgfPetAcq3LJT0CtORkRL3FIs/view?usp=sharing" target="_blank" class="btn-link">
                                                    Students
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-12">
                                            <a class="card-title">7.1.13</a>
                                        </div>
                                        <div id="c6-12" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1_GMEvyjmK5PcGbAMs64pO6iufZkZiIMF/view?usp=sharing" target="_blank" class="btn-link">
                                            Institution Core Values
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-13">
                                            <a class="card-title">7.1.14</a>
                                        </div>
                                        <div id="c6-13" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1PlnRpU_zbNuHz5H_nPRoGhtOdehpEmIc/view?usp=sharing" target="_blank" class="btn-link">
                                            Fundamental duties & rights of Indian Citizen
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-14">
                                            <a class="card-title">7.1.15</a>
                                        </div>
                                        <div id="c6-14" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1K8Vd7qey6FFnUjEGYvyNWGrYOmBNWjlB/view?usp=sharing" target="_blank" class="btn-link">
                                            Human Values & Professional Ethics
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-15">
                                            <a class="card-title">7.1.16</a>
                                        </div>
                                        <div id="c6-15" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1MycgaQcFDc77ZmBlxJQFkS7jMiK_wNn7/view?usp=sharing" target="_blank" class="btn-link">
                                            UNIVERSITY ( Affiliation Letter)
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-16">
                                            <a class="card-title">7.1.17</a>
                                        </div>
                                        <div id="c6-16" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1828d_KP36_0nNncxBoLB2PBEal5BRM0A/view?usp=sharing" target="_blank" class="btn-link">
                                            Program on Human Universal Values
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-17">
                                            <a class="card-title">7.1.18</a>
                                        </div>
                                        <div id="c6-17" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/10dBFy3YVMYmA_zqHGgRxWsr2_FG1NFI-/view?usp=sharing" target="_blank" class="btn-link">
                                            National Festivals
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-18">
                                            <a class="card-title">7.1.19</a>
                                        </div>
                                        <div id="c6-18" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1Z57JnUKp_vvKPn5R57ytWxSAaHz0Eu0n/view?usp=sharing" target="_blank" class="btn-link">
                                            Transparency in Financial, Academic, Administrative
                                            </a>  
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-19">
                                            <a class="card-title">7.2.1</a>
                                        </div>
                                        <div id="c6-19" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1bV4HoiUbsJkxAKPIUjskFTqWt5MOzdmE/view?usp=sharing" target="_blank" class="btn-link">
                                            Best Practices
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header collapsed" data-toggle="collapse" data-parent="#accordion13" href="#c6-20">
                                            <a class="card-title">7.3.1</a>
                                        </div>
                                        <div id="c6-20" class="card-body collapse" data-parent="#accordion13" >
                                            <a href="https://drive.google.com/file/d/1VoAjDeSg0TWuaW7g9n9gnquPCFWpGkcn/view?usp=sharing" target="_blank" class="btn-link">
                                            Distinctiveness to its vision, priority and thrust
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab8" role="tabpanel" aria-labelledby="tab8-tab">
                        <div class="inner-title"  >
                            <h3>Extended Template Documents
                            </h3>
                           
                        </div>
                        <div class="row justify-content-center">
                          <div class="col-md-4 col-6">
                            <div class="pdf-box">
                                <div class="pdf-icon">
                                    <span><i class="fa fa-file-pdf-o"></i></span>
                                </div>
                                <h5>3.2 extended format</h5>            
                                <a class="button-text" href="https://drive.google.com/file/d/1gaOH7M_qjRT5RA4gAV4DOhIlnHaZRz_A/view?usp=sharing" target="_blank">Read More</a>
                            </div>
                          </div>
                          <div class="col-md-4 col-6">
                            <div class="pdf-box">
                                <div class="pdf-icon">
                                    <span><i class="fa fa-file-pdf-o"></i></span>
                                </div>
                                <h5>3.1a &amp; 3.1b Extended profile</h5>            
                                <a class="button-text" href="https://drive.google.com/file/d/1aQOQBqC-1AIdqyaavZ3gQUpgE2YLOdL3/view?usp=sharing" target="_blank">Read More</a>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab9" role="tabpanel" aria-labelledby="tab9-tab">
                        <div class="inner-title"  >
                            <h3>Clarification
                            </h3>
                           
                        </div>
                        <app-clarification-inner></app-clarification-inner>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>